import { type Epic, combineEpics } from 'redux-observable';
import { filter, map } from 'rxjs';
import { request } from '@/core';
import { fetchLogoCollectionRequest } from '@/api/teams/fetchLogoCollectionRequest';
import { fetchCollection, setCollection } from '../actions';

const fetchCollectionEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchCollection.match),
    request(
      ({ payload }) => fetchLogoCollectionRequest(payload),
      fetchCollection,
    ),
  );

const fetchCollectionSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchCollection.succeeded.match),
    map(({ payload: { data } }) => setCollection(data.data)),
  );

export default combineEpics(fetchCollectionEpic, fetchCollectionSucceededEpic);
